import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Flex, Row, Col, Image } from "antd";
import { useNavigate } from "react-router-dom";
import "../../Styles/login.css";
import useLogin from "../../services/hooks/useLogin";

const ForgetPassword = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [isLoading, error, handleForgotPassword] = useLogin("auth/forgot-password");

  const handleRedirectLogin = () => {
    navigate('/')
  }
  const onFinish = async (values) => {
    // setIsLoggedIn(true);
    // navigate("/dashboard");
    // console.log("Success:", values);

    try {
      await handleForgotPassword(values)
    } catch (error) {
      setLoginError(error.message);
    } finally {
      setLoading(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Row justify="center" align="middle" gutter={16} className="form_section">
      <Col md={12}>
        <div className="forgetPass"></div>
      </Col>
      <Col md={12}>
        <Form
          className="login_form"
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <h3>Forgot your Password ?</h3>

          <hr className="my-4" />
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: "Please input your Email!" }]}
          >
            <Input className="input_field" placeholder="Email" />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              className="btn_submit"
            >
              Reset
            </Button>
          </Form.Item>
          <Form.Item>
            <Flex justify="center" align="center">
              <p onClick={handleRedirectLogin} style={{ cursor: "pointer", color: "#4372C2", fontWeight: '500' }}>Back to Login</p>
            </Flex>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default ForgetPassword;
